module.exports = __webpack_public_path__ + "static/img/2wv2.ae872544.png";